// libraries
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Button, notification, Table } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

// services
import * as SubjectService from '../../../../services/bb-api/subject';
import { txt } from '../../../../locales/i18n';

// components
import { SharedTable } from '../../../shared/table';

export function SubjectTableRoute(): JSX.Element {
	const [loading, setLoading] = useState<boolean>(true);
	const [subjects, setSubjects] = useState<Record<string, any>[]>([]);
	const history = useHistory();

	useEffect(() => {
		async function getSubjects(): Promise<void> {
			setLoading(true);

			try {
				const subjects: Record<string, any>[] = await SubjectService.query();
				setSubjects(subjects);
			} catch (error) {
				const message: string = (error as Error).name;
				const description: string = (error as Error).message;
				notification.error({ message, description });
			}

			setLoading(false);
		}

		getSubjects();
	}, []);

	return (
		<StyledMain>
			<Button type="primary" onClick={() => history.push('/subjects/create')} className="create-button">
				{txt('global.create')} <PlusOutlined />
			</Button>
			<SharedTable
				rowKey="id"
				loading={loading}
				dataSource={subjects}
				onRow={({ id }: Record<string, any>) => ({
					onClick: () => history.push(`/subjects/${id}`),
				})}
			>
				<Table.Column dataIndex="title" title={txt('global.title')} width="24rem" ellipsis />
				<Table.Column dataIndex="metaDescription" title="Meta" ellipsis />
			</SharedTable>
		</StyledMain>
	);
}

const StyledMain = styled.main`
	.create-button {
		margin: 1rem;
	}
`;
